var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"go-top",on:{"click":_vm.scrollToTop}},[_c('svg-icon',{attrs:{"iconClass":"arrow_bottom_g"}}),_c('span',[_vm._v("回頁頂")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }